"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const utils_1 = require("~/utils/utils");
const UI_1 = require("~/components/UI");
const Address_1 = __importDefault(require("~/components/Account/Address"));
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const CustomerDetails_module_scss_1 = __importDefault(require("./CustomerDetails.module.scss"));
function CustomerDetails({ customer, distributirDiscount, sharedProjectsAmount }) {
    var _a, _b;
    const { t } = (0, react_i18next_1.useTranslation)('customer');
    const { activeCustomerDiscount, activeSpecialDiscount } = customer;
    const currentDistributirDiscount = activeSpecialDiscount || distributirDiscount;
    const infoBlock = 'info-block';
    const informationExtrusions = 'information.extrusions';
    const informationRegular = 'information.regular';
    const informationComponents = 'information.components';
    const informationMachining = 'information.machining';
    return customer ? (react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.main },
        react_1.default.createElement(UI_1.Scrollable, { direction: "vertical", scrollbar: true },
            react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default['main-container'] },
                react_1.default.createElement("p", { className: CustomerDetails_module_scss_1.default.title }, customer.firstName),
                react_1.default.createElement("p", { className: CustomerDetails_module_scss_1.default.title }, customer.lastName),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.company')),
                    react_1.default.createElement("div", null, (_a = customer.companyName) !== null && _a !== void 0 ? _a : '-')),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.email')),
                    react_1.default.createElement("div", null, customer.email)),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.phone-number')),
                    react_1.default.createElement("div", null, customer.phoneNumber ? (react_1.default.createElement(react_phone_input_2_1.default, { value: customer.phoneNumber, disabled: true, inputClass: CustomerDetails_module_scss_1.default.number, buttonClass: CustomerDetails_module_scss_1.default.numberDropdown })) : ('-'))),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.projects-number')),
                    react_1.default.createElement("div", null, sharedProjectsAmount)),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.your-price')),
                    currentDistributirDiscount ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null,
                            t(informationExtrusions),
                            ":",
                            ' ',
                            (currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.extrusionsDiscount)
                                ? `-${currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.extrusionsDiscount}%`
                                : t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationComponents),
                            ":",
                            ' ',
                            (currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.componentsDiscount)
                                ? `-${currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.componentsDiscount}%`
                                : t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationMachining),
                            ":",
                            ' ',
                            (currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.machiningDiscount)
                                ? `-${currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.machiningDiscount}%`
                                : t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t('information.start-date'),
                            ":",
                            ' ',
                            (currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.startDate)
                                ? (0, utils_1.dateToShortFormat)(new Date(currentDistributirDiscount.startDate))
                                : '-'),
                        react_1.default.createElement("div", null,
                            t('information.expiration'),
                            ":",
                            ' ',
                            (currentDistributirDiscount === null || currentDistributirDiscount === void 0 ? void 0 : currentDistributirDiscount.expirationDate)
                                ? (0, utils_1.dateToShortFormat)(new Date(currentDistributirDiscount.expirationDate))
                                : '-'))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null,
                            t(informationExtrusions),
                            ": ",
                            t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationComponents),
                            ": ",
                            t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationMachining),
                            ": ",
                            t(informationRegular))))),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.customer-price')),
                    activeCustomerDiscount ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null,
                            t(informationExtrusions),
                            ":",
                            ' ',
                            (activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.extrusionsDiscount)
                                ? `-${activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.extrusionsDiscount}%`
                                : t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationComponents),
                            ":",
                            ' ',
                            (activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.componentsDiscount)
                                ? `-${activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.componentsDiscount}%`
                                : t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationMachining),
                            ":",
                            ' ',
                            (activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.machiningDiscount)
                                ? `-${activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.machiningDiscount}%`
                                : t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t('information.start-date'),
                            ":",
                            ' ',
                            (activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.startDate)
                                ? (0, utils_1.dateToShortFormat)(new Date(activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.startDate))
                                : '-'),
                        react_1.default.createElement("div", null,
                            t('information.expiration'),
                            ":",
                            ' ',
                            (activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.expirationDate)
                                ? (0, utils_1.dateToShortFormat)(new Date(activeCustomerDiscount === null || activeCustomerDiscount === void 0 ? void 0 : activeCustomerDiscount.expirationDate))
                                : '-'))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null,
                            t(informationExtrusions),
                            ": ",
                            t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationComponents),
                            ": ",
                            t(informationRegular)),
                        react_1.default.createElement("div", null,
                            t(informationMachining),
                            ": ",
                            t(informationRegular))))),
                react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default[infoBlock] },
                    react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.label }, t('information.shipping-addressess')),
                    ((_b = customer.shippingAddresses) === null || _b === void 0 ? void 0 : _b.length)
                        ? customer.shippingAddresses.map((address) => {
                            return (react_1.default.createElement("div", { className: CustomerDetails_module_scss_1.default.address, key: address.id },
                                react_1.default.createElement(Address_1.default, { address: address })));
                        })
                        : '-'))))) : null;
}
exports.default = CustomerDetails;
